module.exports = __webpack_public_path__ + "img/san-jose-resort-2.a00adcb0.jpg";